interface Piece {
  x: number
  y: number
  vx: number
  vy: number
  size: number
  rotation: number
  spin: number
  color: string
}

export const CONFETTI_COLORS = ['hsl(45 95% 58%)', 'hsl(199 85% 55%)', 'hsl(340 80% 62%)', 'hsl(152 62% 45%)']

const DURATION_MS = 3200
const GRAVITY = 0.32
const DRAG = 0.985

export function burstConfetti(colors: string[], count = 160) {
  if (typeof window === 'undefined' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  const canvas = document.createElement('canvas')
  canvas.setAttribute('aria-hidden', 'true')
  Object.assign(canvas.style, { position: 'fixed', inset: '0', width: '100vw', height: '100vh', pointerEvents: 'none', zIndex: '100' })
  document.body.appendChild(canvas)

  const ratio = window.devicePixelRatio || 1
  canvas.width = window.innerWidth * ratio
  canvas.height = window.innerHeight * ratio
  const context = canvas.getContext('2d')
  if (!context) {
    canvas.remove()
    return
  }
  context.scale(ratio, ratio)

  const width = window.innerWidth
  const height = window.innerHeight
  const pieces: Piece[] = Array.from({ length: count }, (_, index) => {
    const fromLeft = index % 2 === 0
    const angle = ((fromLeft ? -60 : -120) + (Math.random() * 30 - 15)) * (Math.PI / 180)
    const speed = 11 + Math.random() * 9
    return {
      x: fromLeft ? width * 0.1 : width * 0.9,
      y: height * 0.95,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      size: 6 + Math.random() * 6,
      rotation: Math.random() * Math.PI,
      spin: (Math.random() - 0.5) * 0.3,
      color: colors[index % colors.length]
    }
  })

  const startedAt = performance.now()
  const frame = (now: number) => {
    const elapsed = now - startedAt
    context.clearRect(0, 0, width, height)
    context.globalAlpha = Math.max(0, 1 - Math.max(0, elapsed - DURATION_MS * 0.7) / (DURATION_MS * 0.3))
    for (const piece of pieces) {
      piece.vx *= DRAG
      piece.vy = piece.vy * DRAG + GRAVITY
      piece.x += piece.vx
      piece.y += piece.vy
      piece.rotation += piece.spin
      context.save()
      context.translate(piece.x, piece.y)
      context.rotate(piece.rotation)
      context.fillStyle = piece.color
      context.fillRect(-piece.size / 2, -piece.size / 4, piece.size, piece.size / 2)
      context.restore()
    }
    if (elapsed < DURATION_MS) requestAnimationFrame(frame)
    else canvas.remove()
  }
  requestAnimationFrame(frame)
}
